import { createFileRoute, redirect } from '@tanstack/react-router';

import { currentCohort } from '@/cohort-content';
import { ContactDetails } from '@/features/registration';

export const Route = createFileRoute('/$hci_shortname/contact-details')({
	beforeLoad: async () => {
		if (!currentCohort) {
			throw redirect({
				to: '/oops',
			});
		}
	},
	component: () => <ContactDetails cohort={currentCohort} />,
	head: () => ({
		meta: [
			{
				title: `Your contact details | ${currentCohort.name}`,
			},
		],
	}),
});
